import { Plus } from 'lucide-react';
import type { FaqItem } from '../data/faq';

interface FaqProps {
  items: FaqItem[];
}

/**
 * Accessible FAQ list built on native <details>/<summary> - no JS state, each
 * item opens independently. The plus glyph rotates to a cross when open.
 */
export function Faq({ items }: FaqProps) {
  return (
    <div className="mx-auto max-w-3xl divide-y divide-charcoal/10 border-y border-charcoal/10">
      {items.map((item) => (
        <details key={item.q} className="group py-1">
          <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-left">
            <span className="font-display text-lg font-medium text-charcoal sm:text-xl">
              {item.q}
            </span>
            <Plus
              className="h-5 w-5 shrink-0 text-crimson transition-transform duration-300 group-open:rotate-45"
              strokeWidth={1.6}
            />
          </summary>
          <p className="pb-6 pr-10 font-sans text-[0.95rem] font-light leading-relaxed text-stone">
            {item.a}
          </p>
        </details>
      ))}
    </div>
  );
}
